import { ActionCreator } from '@sendoutcards/core'

export const toggleIsNewContactModalOpen = ActionCreator(
  'SET_IS_NEW_CONTACT_MODAL_OPEN',
)

export const toggleIsNewGroupModalOpen = ActionCreator(
  'TOGGLED_IS_NEW_GROUP_MODAL_OPEN',
)
